/* global window */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';

import Cart from '@arreeba/ristoranti-lib/lib/cart';
import i18N from '@arreeba/ristoranti-frontend-lib/lib/helpers/i18n';
import PriceStrategy from '@arreeba/ristoranti-frontend-lib/lib/helpers/price-strategy';

import Button from '../button';
import Modifier from './modifier';
import MenuItemQuantity from './menu-item-quantity';

const scrollToTop = (handler) => {
  const scrollDuration = 500;
  const scrollHeight = handler.scrollY;
  const scrollStep = Math.PI / (scrollDuration / 15);
  const cosParameter = scrollHeight / 2;
  let scrollCount = 0;
  let scrollMargin;
  const scrollInterval = setInterval(() => {
    if (handler.scrollY !== 0) {
      scrollCount += 1;
      scrollMargin = cosParameter - (cosParameter * Math.cos(scrollCount * scrollStep));
      handler.scrollTo(0, (scrollHeight - scrollMargin));
    } else {
      clearInterval(scrollInterval);
    }
  }, 15);
};

const MenuItemBasic = (props) => {
  return (
    <div className="menuItem__content">
      <div className="menuItem__name">
        <h5>{props.name}</h5>
        <p>{props.description}</p>
      </div>
      <span className="menuItem__price">{i18N.formatPrice(props.price)}</span>
    </div>
  );
};

MenuItemBasic.propTypes = {
  available: PropTypes.bool,
  description: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  price: PropTypes.number,
};

class MenuItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showErrors: false,
      modifiersPanelVisibile: false,
      modifiersStatus: this.getDefaultModifiersStatus(this.props.modifiers),
    };
    this.toggleModifiersPanel = this.toggleModifiersPanel.bind(this);
    this.addToCartFn = this.addToCartFn.bind(this);
    this.updateModifier = this.updateModifier.bind(this);
  }

  getDefaultModifiersStatus(modifiers) {
    return modifiers.reduce(
      (acc, m) => ({
        ...acc,
        [m.id]: {
          ...PriceStrategy[m.price_strategy](m),
          items: m.items,
        },
      }), {});
  }

  toggleModifiersPanel(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.props.modifiers.length < 1) {
      console.error('Try to open modifiers panel for item w/o modifiers');
      return;
    }
    this.setState({ modifiersPanelVisibile: !this.state.modifiersPanelVisibile });
  }

  addToCartFn(item) {
    const hasErrors = _.some(this.state.modifiersStatus, { isValid: false });
    if (!this.props.available || hasErrors) {
      this.setState({ showErrors: true });
      this.modifiersWrapper.scrollTop = 0;
      return;
    }
    this.setState({ modifiersPanelVisibile: false });
    this.props.onSelect(item);
    this.setState({
      modifiersStatus: this.getDefaultModifiersStatus(this.props.modifiers),
    });
    // scrollToTop(window);
  }

  updateModifier(modifier, item) {
    const items = this.state.modifiersStatus[modifier.id].update(item);
    const newStatus = {
      ...modifier,
      items,
    };
    this.setState({
      showErrors: _.some(this.state.modifiersStatus, { isValid: false }),
      modifiersStatus: {
        ...this.state.modifiersStatus,
        [modifier.id]: {
          ...PriceStrategy[modifier.price_strategy](newStatus),
          items,
        },
      },
    });
  }

  render() {
    const classes = classNames(
      'menuItem',
      { 'menuItem--unavailable': !this.props.available },
      { 'menuItem--withModifiers': this.props.modifiers.length > 0 },
    );
    if (this.props.modifiers.length < 1) {
      const item = {
        id: this.props.id,
        name: this.props.name,
        price: this.props.price,
        modifiers: [],
      };
      return (
        <button className={classes} onClick={() => this.addToCartFn(item)}>
          <MenuItemQuantity n={this.props.quantity || 0} />
          <MenuItemBasic {...this.props} />
        </button>
      );
    }

    const item = {
      id: this.props.id,
      name: this.props.name,
      price: this.props.price,
      modifiers: this.props.modifiers.map(m => ({
        ...m,
        items: this.state.modifiersStatus[m.id].items.filter(mi => mi.selected),
      })),
    };

    return (
      <div className={classes}>
        <div className="menuItem__header" onClick={this.toggleModifiersPanel}>
          <MenuItemQuantity n={this.props.quantity || 0} />
          <MenuItemBasic {...this.props} />
        </div>
        {this.state.modifiersPanelVisibile &&
          <div
            className="menuItem__modifiersWrapper"
            ref={(node) => { this.modifiersWrapper = node; }}
          >
            <div className="itemModifiers">
              {
                this.props.modifiers.map((m) => {
                  const modifier = {
                    ...m,
                    items: this.state.modifiersStatus[m.id].items,
                  };
                  return (
                    <Modifier
                      key={m.id}
                      onUpdate={this.updateModifier}
                      status={this.state.modifiersStatus[m.id]}
                      data={modifier}
                      showErrors={this.state.showErrors}
                    />
                  );
                })
              }
            </div>
            <footer className="cf menuItem__controls">
              <div>
                <div className="menuItem__subtot">
                  <span>Tot parziale</span>
                  <span className="menuItem__subtotPrice">
                    {i18N.formatPrice(Cart.itemPrice(item))}
                  </span>
                </div>
                <Button
                  type="submit"
                  text="AGGIUNGI ALL'ORDINE"
                  onClick={() => { this.addToCartFn(item); }}
                />
              </div>
            </footer>
          </div>
        }
      </div>
    );
  }
}

MenuItem.propTypes = {
  ...MenuItemBasic.propTypes,
  modifiers: PropTypes.array,
  onSelect: PropTypes.func,
  quantity: PropTypes.number,
};
MenuItem.defultProps = {
  quantity: 0,
};

export default MenuItem;



// WEBPACK FOOTER //
// ./src/components/menu/menu-item.js